module.exports = __webpack_public_path__ + "img/47.e6fb40f9.png";